var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const CloseCircle = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-close_circle ${className}`} {...other}>
      <g>
        <path d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM6.055 4.995l1.946 1.944 1.944-1.944a.5.5 0 01.707 0l.353.353a.5.5 0 010 .707L9.061 8l1.944 1.945a.5.5 0 010 .707l-.353.353a.5.5 0 01-.707 0L8 9.061l-1.945 1.944a.5.5 0 01-.707 0l-.353-.353a.5.5 0 010-.707L6.94 7.999 4.995 6.055a.5.5 0 010-.707l.353-.353a.5.5 0 01.707 0z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default CloseCircle;
